.title {
  font-weight: 500;
}
